import { render, staticRenderFns } from "./TermsOverlay.vue?vue&type=template&id=9a9dd5bc&scoped=true&"
import script from "./TermsOverlay.vue?vue&type=script&lang=js&"
export * from "./TermsOverlay.vue?vue&type=script&lang=js&"
import style0 from "./TermsOverlay.vue?vue&type=style&index=0&id=9a9dd5bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a9dd5bc",
  null
  
)

export default component.exports